import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ao-menu',
  templateUrl: './ao-menu.component.html',
  styleUrls: ['./ao-menu.component.scss']
})
export class AOMenuComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit() {
  }

}
